import SendEmail from './SendEmail';
import FileField from './FileField';
import UWEEntityZipDownloadField from './UWEEntityZipDownloadField';
import BoolYesNoField from './BoolYesNoField';
import IconCheckField from './IconCheckField';
import CheckboxToggleButtonField from './CheckboxToggleButtonField';
import HideObjectField from './HideObjectField';
import RiskMatrixField from './RiskMatrixField';
import RiskMatrixFieldBusiness from './RiskMatrixFieldBusiness';
import SignatureField from './SignatureField';
import CompositeInputField from './CompositeInputField';
import ComputedField from './ComputedField';
import LookupFormField from './LookupFormField';
import LookupFormStaticField from './LookupFormStaticField';
import LookupMultiSelectCheckboxesFormField from './LookupMultiSelectCheckboxesFormField';
import LookupMultiSelectDropdownField from './LookupMultiSelectDropdownField';
import TimerField from './TimerField';
import SubformField from './SubformField';
import MoneyInput from './MoneyInput';
import CedulaInput from './CedulaInput';
import StaticField from './StaticField';
import SwitchField from './SwitchField';
import ToggleObjectField from './ToggleObjectField';
import ArrayField from './ArrayField';
import Autocomplete from './AutocompleteField';
import StaticTextBlurb from './StaticTextBlurb';
import InteractiveDrawing from './InteractiveDrawing';
import InputColorPicker from './InputColorPicker';
import JnxField from './JnxField';
import JsonField from './JsonField';
import SelectImageField from './SelectImageField';
import QRCode from './QRCode';
import QrRead from './QrRead';
import OcifReportAmendmentsList from './OcifReportAmendmentsList';
import StaticIFrame from './StaticIFrame';
import TimeInputField from './TimeInputField';
import DurationInput from './DurationInput';
import ChangeFont from './ChangeFont';
import AddressMapWidget from './MapInput';
import CheckboxField from './CheckboxField';
import LookupConfigurationField from './LookupConfigurationField';
import StaticMarkdownBlurb from './StaticMarkdownBlurb';
import HtmlEditor from './HtmlEditor';
import TextInput from './TextInput';
import PhoneInput from './PhoneInput';
import Button from './Button';
import OcifBulkUploadPanel from './OcifBulkUpload';
import OcifInventoryScheduleUploadPanel from './OcifInventoryScheduleUpload';
import OcifReviewSummaryPanel from './OcifReviewSummary';
import LoadingField from './LoadingField';
import KeyValueAssignmentField from './KeyValueAssignmentField';
import CheckboxWidget from './CheckboxWidget';
import DateTimeWidget from './DateTimeWidget';
import SkillFileListField from './SkillFileListField';
import SupersetDashboardField from './SupersetDashboardField';
import UnsupportedField from './UnsupportedField';
import WorkflowDocumentField from './WorkflowDocumentField';
import DatePeriodFilterField from './DatePeriodFilterField';
import OcifAccessRequestList from './OcifAccessRequestList';
import OcifParentRequirementsField from './OcifParentRequirementsField';
import OcifRequiredSchedulesField from './OcifRequiredSchedules/OcifRequiredSchedulesField';

const customFields = {
  SendEmail,
  FileField,
  UWEEntityZipDownloadField,
  RiskMatrixField,
  RiskMatrixFieldBusiness,
  ComputedField,
  SignatureField,
  CompositeInputField,
  HideObjectField,
  BoolYesNoField,
  BoolYesNo: BoolYesNoField,
  IconCheckField,
  InputColorPicker,
  CheckboxToggleButtonField,
  CheckboxField,
  LookupFormField,
  LookupFormStaticField,
  LookupMultiSelectCheckboxesFormField,
  LookupMultiSelectDropdownField,
  TimerField,
  JnxField,
  JsonField,
  SelectImageField,
  MoneyInput,
  SubformField,
  CedulaInput,
  StaticField,
  ArrayField,
  SwitchField,
  ToggleObjectField,
  OcifReportAmendmentsList,
  // Temporary measure, component renamed
  WorktrayEntitySelectField: OcifReportAmendmentsList,
  Autocomplete,
  StaticTextBlurb,
  InteractiveDrawing,
  QRCode,
  QrRead,
  StaticIFrame,
  TimeInputField,
  DurationInput,
  ChangeFont,
  AddressMapWidget,
  LookupConfigurationField,
  StaticMarkdownBlurb,
  HtmlEditor,
  TextInput,
  PhoneInput,
  Button,
  OcifBulkUploadPanel,
  OcifInventoryScheduleUploadPanel,
  OcifReviewSummaryPanel,
  LoadingField,
  KeyValueAssignmentField,
  CheckboxWidget,
  DateTimeWidget,
  SkillFileListField,
  SupersetDashboardField,
  UnsupportedField,
  WorkflowDocumentField,
  DatePeriodFilterField,
  OcifAccessRequestList,
  OcifParentRequirementsField,
  OcifRequiredSchedulesField,
};

export default customFields;
